// Mirrors backend/internal/domain/thread.go's maxTitleLen/maxBodyLen and
// post.go's maxBodyLen exactly -- the backend is the real enforcement,
// these are presentation-layer feedback only (whole-app critique
// 2026-09-02: neither field had a client-side limit despite the backend
// rejecting anything longer). Shared here rather than duplicated once a
// second call site needed the same value (create-thread's title/body,
// thread-detail's reply body -- final review, PR #51), matching this
// project's own established extract-at-second-call-site pattern
// (relativeTime, useCurrentLocation).
export const MAX_THREAD_TITLE_LEN = 200;
export const MAX_THREAD_BODY_LEN = 5000;
export const MAX_POST_BODY_LEN = 5000;

// Mirrors domain/profile.go's profileHandleValid exactly (issue #122):
// the backend is the real enforcement, this is presentation-layer
// feedback so the form explains a rejection instead of blaming the
// connection.
export const HANDLE_MIN_LEN = 2;
export const HANDLE_MAX_LEN = 30;

export function profileHandleValid(handle: string): boolean {
  if (handle.length < HANDLE_MIN_LEN || handle.length > HANDLE_MAX_LEN) {
    return false;
  }

  return /^[A-Za-z0-9_-]+$/.test(handle);
}

export const HANDLE_POLICY_COPY = '2-30 characters: letters, digits, underscores, or hyphens';

// Mirrors domain.MaxPhotosPerProfile (backend/internal/domain/photo.go)
// exactly -- lets the profile edit screen disable "Add photo" at the
// cap instead of only discovering it from a 409 after a round trip.
export const MAX_PHOTOS = 6;

// Mirrors domain/profile.go's maxPrompts exactly (issue #216) -- the
// backend is the real enforcement (ErrTooManyPrompts), this is
// presentation-layer feedback so the prompt picker can disable itself
// at the cap instead of only discovering it from a 400 after a round
// trip. Note maxPrompts itself is a documented assumption on the
// backend side, not a design.md-specified number -- if that number
// ever changes, this constant needs to change with it.
export const MAX_PROMPTS = 3;

// Mirrors the backend's maxMessageLen (internal/domain/message.go)
// exactly -- the backend is the real enforcement (ErrMessageBodyTooLong),
// this is presentation-layer feedback so the composer can show the limit
// before a round trip. api.ts's "message body is too long" copy reads
// this too, so the number has one source on this side.
export const MAX_MESSAGE_LEN = 2000;

// Frontend-only UX guidance, not backend-enforced (the backend places
// no length limit on a prompt answer today) -- keeps prompt answers in
// the short, scannable register issue #216 asks for ("Hinge/Bumble
// prompt pattern"), not a second bio-length free-write field.
export const MAX_PROMPT_ANSWER_LEN = 300;
